import React from "react";
import "../css/dashboard.css";
import ClientsContent from "./ClientsContent";
import Navbar from "../component/Navbar";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ClientsContentMobile from "./ClientsContentMobile";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";

export default function ClientsFiltered() {
  const navigate = useNavigate();

  const handleMenuOpen = () => {
    navigate("/menumobile");
  };

  const isMobile = useMediaQuery({ query: "(max-width: 800px)" });

  return (
    <div className="main-container">
      {isMobile ? (
        <>
          <div className="menu-button-container">
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleMenuOpen}
              className="menu-button"
            >
              <MenuIcon />
            </IconButton>
          </div>

          <ClientsContentMobile filterByTherapist title="My Clients" />
        </>
      ) : (
        <>
          <Navbar linkActive={21} />
          <ClientsContent filterByTherapist title="My Clients" />
        </>
      )}
    </div>
  );
}
